import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Snackbar from '../../../components/snackbar/Snackbar';

const PdfGeneratorWrapper = props => {
    const { url, getPdfData, isSnackbarOpen, onCloseSnackbar, downloadPdf, pdfConfiguration } =
        props;

    useEffect(() => {
        downloadPdf(url, pdfConfiguration, getPdfData(props));
    }, []);

    return (
        isSnackbarOpen && (
            <Snackbar
                message={`${pdfConfiguration.fileName}.pdf is generating... `}
                className="snackbar"
                onCloseSnackbar={onCloseSnackbar}
            />
        )
    );
};

PdfGeneratorWrapper.defaultProps = {
    url: '',
    isSnackbarOpen: false,
    pdfConfiguration: {
        fileName: '',
    },
    getPdfData: () => {},
    onCloseSnackbar: () => {},
    downloadPdf: () => {},
};

PdfGeneratorWrapper.propTypes = {
    url: PropTypes.string,
    getPdfData: PropTypes.func,
    pdfConfiguration: PropTypes.object,
    isSnackbarOpen: PropTypes.bool,
    onCloseSnackbar: PropTypes.func,
    downloadPdf: PropTypes.func,
};

export default PdfGeneratorWrapper;
